import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest, HttpEvent } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { tap } from 'rxjs/operators';

import { Config } from '../../config/config';
@Injectable({
  providedIn: 'root'
})
export class CtbCsdService {
  dataUrl = Config.URL_BASE;
  constructor(private http: HttpClient) {

  }
  post(dto: any): Observable<any> {
    let url_ = this.dataUrl + '/csd/post';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_, dto).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  get(idEmp: number): Observable<any> {
    let url_ = this.dataUrl + '/csd/get/' + idEmp;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  postCerKey(archivo1: File, archivo2: File, id: number) {
    const formData = new FormData();
    formData.append('cer', archivo1);
    formData.append('key', archivo2);
    const req = new HttpRequest('POST', this.dataUrl + '/csd/post/certificadokey/' + id, formData, {
      reportProgress: true
    });
    return this.http.request(req);
  }
  getKey(id: number) {
    let url_ = this.dataUrl + '/csd/download/key/' + id;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get( url_, {responseType: 'blob'}).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  getCer(id: number) {
    let url_ = this.dataUrl + '/csd/download/certificado/' + id;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get( url_, {responseType: 'blob'}).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  delete(idEmp: number): Observable<any> {
    let url_ = this.dataUrl + '/csd/delete/' + idEmp;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.delete(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
}
export class CtbConfEmp {
  id: number;
  rfc: String | undefined = '';
  nombre: String | undefined = '';
  catalogo: String | undefined = '';
  estructura: String | undefined = '';
  estructura1: String | undefined = '';
  fecha_inicio: string;
  fecha_fin: string;
  periodo: number;
  catalogoPresente: boolean;
  numero_periodos: number | undefined = 12;
  periodo_vigente: number;
  al: string;
  obligarAsignarSat: boolean;
  del: string;
  momento_crea: String;
  momento_actualiza: String;
  momento_baja: String;
  gralUsrCreaId: number;
  gralUsrActualizaId: number;
  gralUsrBajaId: number;
  emp: GralEmp;
}
export class CtbCtaDefault {
  id: number;
  titulo: String;
}
export class GralEmp {
  id?: number;
  titulo?: String | null | undefined = '';
  rfc?: String | null | undefined = '';
  nombre_comercial: String | null | undefined = '';
  seleccionado?: boolean;
  suc?: any;
}
export class PageBusquedaObject {
  column?: string | undefined;
  criteriaSearch?: any | undefined;
  itemsPerPage?: number | undefined;
  order?: string | undefined;
  pageNumber?: number | undefined;
  sort?: boolean | undefined;
}
